import { TextField as MUITextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import React from 'react';

const TextField = (props) => {
  const { name = '', label, defaultValue = '', ...otherProps } = props;

  const {
    register,
    setValue,
    formState: { errors },
  } = useFormContext();

  const handleBlur = (e) => {
    if (name !== 'website') {
      return;
    }

    let value = e.target.value.trim();
    // Only prepend https:// if it's not already there
    if (value && !/^https?:\/\//i.test(value)) {
      value = `https://${value}`;
      setValue(name, value, { shouldValidate: true });
    }

    // Regex to ensure a valid domain is entered (including TLD like .com, .net, etc.)
    const validUrlPattern = /^(http:\/\/|https:\/\/)([a-z0-9-]+\.)+[a-z]{2,6}(\.[a-z]{2})?(\/)?(.+)?$/i;
    const invalidUrlPattern = /^(http:\/\/|https:\/\/)www.[a-z]{2,}/i;
    if (value && (!validUrlPattern.test(value) || invalidUrlPattern.test(value))) {
      setValue(name, '', { shouldValidate: true });
    }
  };

  return (
    <MUITextField
      label={label}
      fullWidth
      margin='normal'
      defaultValue={defaultValue}
      {...register(name, {
        onBlur: handleBlur,
      })}
      error={Boolean(errors?.[name])}
      helperText={errors?.[name]?.message || ''}
      {...otherProps}
    />
  );
};

export default TextField;
